import React from 'react';
import classnames from 'classnames';
import { Tooltip } from 'Components/nui';
import * as R from 'ramda';
import { FormattedMessage } from 'react-intl';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const RefPriceContentColumn = ColumnTree.defineNode(
  'ref-price-content',
  {
    predicate({ solutionColumns }) {
      return R.path(['reference_price', 'type'], solutionColumns) === 'display';
    },
    make({ sortDirection, sortColumn, setSort }) {
      return {
        title: (
          <Tooltip
            title={
              <span className="icon-tooltip">
                <span className="icon-info-circled"></span>
                <FormattedMessage
                  id="marketplace-table-heading-refprice-tooltip"
                  defaultMessage="Reference price - Price per reference unit (eg Tonne) for price comparison across next pack sizes"
                />
              </span>
            }
          >
            <a
              href="#ref-price"
              className={classnames('icon-sort', 'sortem', {
                [sortDirection]: sortColumn === 'ref-price',
              })}
              onClick={() => setSort('ref-price')}
            >
              <FormattedMessage
                id="marketplace-table-heading-refprice"
                defaultMessage="Ref. price"
              />{' '}
              <span className="show-help inline-block" />
            </a>
          </Tooltip>
        ),
        key: 'ref-price',
        className: 'col-ref-price',
        render: (text, record) => (
          <div className="td-content">
            {record.price?.std && (
              <span>
                <strong className="all-black">
                  {R.path(['price', 'std', 'price'], record)}
                </strong>{' '}
                <span className="unit">
                  {R.path(['price', 'std', 'unit'], record)}
                </span>
              </span>
            )}
          </div>
        ),
      };
    },
  }
);
